import { IntakePartOfDay } from "interfaces/jsona-models/TherapyJSONAModel";

export const intakePartOfDayCollection = [
  IntakePartOfDay.MorningEmptyStomach,
  IntakePartOfDay.Morning,
  IntakePartOfDay.Afternoon,
  IntakePartOfDay.Night,
  IntakePartOfDay.NonApplicable,
];
